import { render } from "./Touzi.vue?vue&type=template&id=2aecc7fa"
import script from "./Touzi.vue?vue&type=script&lang=js"
export * from "./Touzi.vue?vue&type=script&lang=js"

import "./Touzi.vue?vue&type=style&index=0&id=2aecc7fa&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__